/* Shop the Look: move through campaign posts without returning to the grid. */
document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-gram-nav]');
  if (!control) return;

  const current = control.closest('dotto-modal[data-gram-modal]');
  if (!current) return;

  const sectionId = current.dataset.gramModal;
  const modals = Array.from(document.querySelectorAll(`dotto-modal[data-gram-modal="${sectionId}"]`));
  const currentIndex = modals.indexOf(current);
  if (currentIndex === -1 || modals.length < 2) return;

  event.preventDefault();
  const direction = control.dataset.gramNav === 'next' ? 1 : -1;
  const target = modals[(currentIndex + direction + modals.length) % modals.length];
  current.close();
  target.open(control);
});
